import { GET_PRODUCT_REQUEST, GET_PRODUCT_SUCCESS, GET_PRODUCT_FAIL, 
    CREATE_PRODUCT_REQUEST, CREATE_PRODUCT_SUCCESS, CREATE_PRODUCT_FAIL,
    UPDATE_PRODUCT_REQUEST, UPDATE_PRODUCT_SUCCESS, UPDATE_PRODUCT_FAIL,
    DELETE_PRODUCT_REQUEST, DELETE_PRODUCT_SUCCESS, DELETE_PRODUCT_FAIL } from "../types/productMasterTypes";
import Axios from 'axios';
import APP_CONSTANT from '../../config/constants';
import cogoToast from "cogo-toast";


export const deleteProduct = (id) => async (dispatch) => {

    dispatch({ type: DELETE_PRODUCT_REQUEST });

    try {
        
        const headerData = {
            "api_token": localStorage.getItem('apiToken'),
            "customerNo": localStorage.getItem('customerNo'),
            "userId": localStorage.getItem('userId'),
            "tyreId": id
        }

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}public/api/pslineitem/delete`, headerData);
        dispatch({ type: DELETE_PRODUCT_SUCCESS, payload: data });
            
    } catch (error) {   
        if(error.response.data.status === 400){
            cogoToast.error(error.response.data.message, { position: 'top-right' })
        }
        dispatch({ type: DELETE_PRODUCT_FAIL, payload: error.message })
    }
}

export const updateProduct = (productData) => async (dispatch) => {

    dispatch({ type: UPDATE_PRODUCT_REQUEST });

    try {
        
        const headerData = {
            "api_token": localStorage.getItem('apiToken'),
            "customerNo": localStorage.getItem('customerNo'),
            "userId": localStorage.getItem('userId'),
            "imageFile": productData.image,
            "psCode": productData.productCode,
            "psDescription": productData.productName,
            "type": '1',
            "accountGroupId": '1',
            "uom": productData.uom,
            "categoryId": productData.category,
            "height": productData.height,
            "width": productData.width,
            "length": productData.length,
            "weight": productData.weight,
            "gstPercentage": productData.gst,
            "tdsPercentageId": productData.tds,
            "purchasePrice": productData.purchasePrice,
            "purchaseDesc": productData.purchaseDescription,
            "sellingPrice": productData.sellingPrice,
            "sellingDesc": productData.sellingDescription,
            "reorderLevel": productData.reorderLevel,
            "openingStock": productData.openingStock,
            "productId": "3"
        }

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}public/api/pslineitem/update`, headerData);
        dispatch({ type: UPDATE_PRODUCT_SUCCESS, payload: data });
            
    } catch (error) {  
        if(error.response.data.status === 400){
            cogoToast.error(error.response.data.message, { position: 'top-right' })
        } 
        dispatch({ type: UPDATE_PRODUCT_FAIL, payload: error.message })
    }
}

export const createProduct = (productData) => async (dispatch) => {

    dispatch({ type: CREATE_PRODUCT_REQUEST });

    try {
        
        const headerData = {
            "api_token": localStorage.getItem('apiToken'),
            "customerNo": localStorage.getItem('customerNo'),
            "userId": localStorage.getItem('userId'),
            "imageFile": productData.image,
            "psCode": productData.productCode,
            "psDescription": productData.productName,
            "type": '1',
            "accountGroupId": '1',
            "uom": productData.uom,
            "categoryId": productData.category,
            "height": productData.height,
            "width": productData.width,
            "length": productData.length,
            "weight": productData.weight,
            "gstPercentage": productData.gst,
            "tdsPercentageId": productData.tds,
            "purchasePrice": productData.purchasePrice,
            "purchaseDesc": productData.purchaseDescription,
            "sellingPrice": productData.sellingPrice,
            "sellingDesc": productData.sellingDescription,
            "reorderLevel": productData.reorderLevel,
            "openingStock": productData.openingStock,
            "productId": "3"
        }

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}public/api/pslineitem/create`, headerData);
        dispatch({ type: CREATE_PRODUCT_SUCCESS, payload: data });
            
    } catch (error) {   
        if(error.response.data.status === 400){
            cogoToast.error(error.response.data.message, { position: 'top-right' })
        }
        dispatch({ type: CREATE_PRODUCT_FAIL, payload: error.message })
    }
}

export const getProduct = (id) => async (dispatch) => {

    dispatch({ type: GET_PRODUCT_REQUEST });

    try {
        
        const headerData = {
            "api_token": localStorage.getItem('apiToken'),
            "customerNo": localStorage.getItem('customerNo'),
            "userId": localStorage.getItem('userId'),
            "type": [1,2],
            "checkDeletedRecord" : "1"
        }

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}public/api/pslineitem/getPS`, headerData);
        dispatch({ type: GET_PRODUCT_SUCCESS, payload: data });
            
    } catch (error) {
        if(error.response.data.status === 400){
            cogoToast.error(error.response.data.message, { position: 'top-right' })
        }
        dispatch({ type: GET_PRODUCT_FAIL, payload: error.message })
    }
}